module.exports = __webpack_public_path__ + "0c72ab82342154cb1b18f5eacb6a774e.svg";